import { escapeHtml } from "../../utils"

export const makePageHeaderRow = ({ dateFormat, gridInfo, name = "Header" }: MakePageHeaderRowProps) => {
  return {
    id: "headerRow",
    Name: name,
    Space: -1,
    Visible: 0,
    PanelVisible: 0,
    CanExport: 0,
    CanPrint: 2,
    Cells: "Logo,GridInfo,PrintDate",
    LogoRelWidth: 1,
    LogoAligh: "Left",
    LogoVAligh: "middle",
    LogoType: "Html",
    Logo: `<img style="height: 40px;" src="/favicon.png"  alt="company logo"/>`,
    PrintDate: new Date(),
    PrintDateType: "Date",
    PrintDateFormat: dateFormat,
    PrintDateCanEdit: 0,
    GridInfo: `<span class="largeText">${escapeHtml(gridInfo)}<span>`,
    GridInfoType: "Html",
    GridInfoRelWidth: 2,
  }
}

type MakePageHeaderRowProps = {
  dateFormat: string
  gridInfo: string
  name?: string
}
